import { Box, Typography, Stack, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { useMe } from '../api/hooks.js';
import { ApiTokensSection, ConnectedAssistants } from '../components/ApiTokensSection.js';
import { useT } from '../i18n/useT.js';

/**
 * Programmatic access to the organization: server API tokens, and the
 * assistants somebody has connected over MCP.
 *
 * These lived on a project's API Keys page, beside the SDK ingest keys. They
 * were never per-project — a token carries an organization and a role, and no
 * MCP tool takes a project it has to be given — but sitting under
 * `/projects/:id/api-keys` said otherwise, and somebody reading that page
 * reasonably concluded they needed one token per project. The scope was right
 * in the code and wrong on the screen, which is the kind of thing only a
 * person trying to use it notices.
 */
export function ApiAccessPage() {
  const t = useT().keys.access;
  const { data: me } = useMe();
  const orgId = me?.organizations[0]?.id;

  return (
    <Box>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.5 }}>
        <HubIcon color="primary" />
        <Typography variant="h5" fontWeight={700}>
          {t.title}
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 760 }}>
        {t.subtitle}
      </Typography>

      <Alert severity="info" variant="outlined" sx={{ mb: 1, maxWidth: 760 }}>
        {t.ingestPointer}{' '}
        <MuiLink component={RouterLink} to="/projects">
          {t.ingestPointerLink}
        </MuiLink>
        .
      </Alert>

      <ApiTokensSection orgId={orgId} />
      {/* Personal, not administrative: whoever approved an assistant must be
          able to take it back, whatever their role. */}
      <ConnectedAssistants />
    </Box>
  );
}
